/**
 * Controls the visibility of which kind of entry (actual or estimate)
 * the user can use for entering their energy usage
 * @module embed/energy_usage
 */

import { show, hide } from '@/lib/show_hide';
import { delegate } from '@/lib/events';

const SELECTOR = '.js-actual-consumption';
const SELECTOR_TYPES = '.js-actual-consumption__types';
const SELECTOR_ACTUAL = '.js-actual-consumption__actual';
const SELECTOR_ESTIMATES = '.js-actual-consumption__estimates';

export default function setupEnergyUsages() {
  document.addEventListener(
    'change',
    // We want an easy access to the container of both the types
    // and the actual/estimates fields
    delegate(SELECTOR, function(event, delegateTarget) {
      // But actually, we're only interested in the changes happening in the types
      delegate(SELECTOR_TYPES, () => {
        if (event.target.value == 'unknown') {
          hide(delegateTarget.querySelector(SELECTOR_ACTUAL), {
            disableControls: true
          });
          show(delegateTarget.querySelector(SELECTOR_ESTIMATES), {
            enableControls: true,
            notify: true
          });
        } else {
          show(delegateTarget.querySelector(SELECTOR_ACTUAL), {
            enableControls: true,
            notify: true
          });
          hide(delegateTarget.querySelector(SELECTOR_ESTIMATES), {
            disableControls: true
          });
        }
      })(event);
    })
  );
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/embed/energy_usage.js